import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getContext from 'recompose/getContext';
import { compose } from 'redux';
import BottomBackground from '../components/BottomBackground';
import { getScreenStyles } from '../selectors/layout';
import { getBottomBackgroundColour } from '../selectors/screen';
function mapStateToProps(state, _a) {
    var isCurrentScreen = _a.isCurrentScreen;
    return {
        backgroundColor: getBottomBackgroundColour(state, isCurrentScreen),
        width: getScreenStyles(state, isCurrentScreen).imageWidth,
    };
}
export default compose(getContext({ isCurrentScreen: PropTypes.bool.isRequired }), connect(mapStateToProps))(BottomBackground);
